export const isDraftAddressKey = (addressKey: unknown): boolean => addressKey === null || addressKey === 'new'
